const tw = {
  companyName: '揚揚創新科技有限公司',
  edit: '修改資料',
  userTrackingAct: {
    description1: "協助您取得現場資訊",
    description2: "即時交換廠商資料",
    description3: "自動寄送當日活動資料",
    description4: "方便追蹤與聯絡",
    description5: "不需重複填寫資料",
    description6: "無紙化遞送品牌資訊",
    next: '開始使用',
    next1: '下一步',
    declarationTitle: '個資使用聲明',
    declarationDetail1: '依據個人資料保護法等相關規定，本服務有義務告知以下事項：',
    declarationDetail2: '同意利用 1Click 進行「',
    declarationDetail3: '」，將提供您的「使用者資訊」至「',
    declarationDetail4: '」，其個人資料的利用之期間、對象、地區及方式，皆以該系統或該單位的「隱私權公告」為主， 本次蒐集之個人資訊，僅限「',
    declarationDetail5: '」使用，並遵守個人資料保護法相關規定，保障使用者的個資。',
    termOfUse1: '同意',
    termOfUse2: '使用條款',
    termOfUse3: '(本欄位需勾選，若無勾選將無法完成本服務申請，也無法使用本服務。)',
    termOfUse4: '必勾選，若無法勾選將無法完成本服務申請，也無法使用本服務。',
    requestFor1: '我要索取品牌資料（品牌聯繫資訊 / 數位型錄..等相關資料）。',
    requestFor2: '品牌資料將於您入場當日展覽/活動結束後，自動彙整您的索取紀錄寄送至您所填寫的電子信箱。',
    confirm: '確認',
    inputNotice: '請填寫以下資訊，以獲取品牌聯繫資訊與產品/服務數位型錄',
    userName: '姓名',
    userNamePlaceHolder: '請輸入姓名',
    userEmail: '連絡信箱',
    userEmailNotice: '請填寫您的連絡信箱收取參展資料',
    userEmailPlaceHolder: '請輸入連絡信箱',
    userPhone: '手機號碼',
    userPhonePlaceHolder: '請輸入手機號碼',
    userCompany: '公司名稱',
    userCompanyPlaceHolder: '請輸入公司名稱',
    userJobTitle: '職務',
    userJobTitlePlaceHolder: '請選擇您的職務類別',
    userIndustry: '行業類型',
    userIndustryPlaceHolder: '請選擇您的行業類別',
    back: '上一步',
  },
  userTrackingResult: {
    description1: '感謝使用1Click索取該品牌相關資訊。 您索取的觀展資料將於您入場當日展覽/活動結束後，自動彙整您的索取紀錄寄送至您所填寫的電子信箱。',
    openAttachment: '請點此打開本品牌電子型錄',
  },
  visitorReport: {
    description1: '您好，感謝您在「',
    description2: '」使用1Click商聯快通服務，以下為您在活動期間參訪品牌的清單與電子型錄連結。',
    description3: '',
    description4: ' - 參訪清單',
    description5: '日期：',
    col1: '參訪時間',
    col2: '公司名稱',
    col3: '姓名',
    col4: '聯絡電話',
    col5: '電子信箱',
    col6: '電子型錄',
    link: '連結',
  },
  boothReport: {
    description1: '，感謝您使用1Click商聯快通服務，以為下造訪您的展位與索取電子型錄者清單。',
    description2: '',
    description3: ' - 來訪清單',
    description4: '日期：',
    col1: '參訪時間',
    col2: '公司名稱',
    col3: '產業類型',
    col4: '姓名',
    col5: '職務',
    col6: '聯絡電話',
    col7: '電子信箱',
  },
};

export default tw;
